export const FETCH_REMINDER_TEMPLATES_REQUEST = 'FETCH_REMINDER_TEMPLATES_REQUEST'
export const FETCH_REMINDER_TEMPLATES_SUCCESS = 'FETCH_REMINDER_TEMPLATES_SUCCESS'
export const FETCH_REMINDER_TEMPLATES_FALUIRE = 'FETCH_REMINDER_TEMPLATES_FALUIRE'
